export default __webpack_public_path__ + "static/media/kyc-exclaimation-icon.ed7fdd48.svg";